import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {MainComponent} from '@modules/main/main.component';
import {BlankComponent} from '@pages/blank/blank.component';
import {LoginComponent} from '@modules/login/login.component';
import {ProfileComponent} from '@pages/profile/profile.component';
import {RegisterComponent} from '@modules/register/register.component';
import {DashboardComponent} from '@pages/dashboard/dashboard.component';
import {AuthGuard} from '@guards/auth.guard';
import {NonAuthGuard} from '@guards/non-auth.guard';
import {ForgotPasswordComponent} from '@modules/forgot-password/forgot-password.component';
import {RecoverPasswordComponent} from '@modules/recover-password/recover-password.component';
import {SubMenuComponent} from '@pages/main-menu/sub-menu/sub-menu.component';
import {RegistrationComponent} from '@pages/registration/registration.component';
import { EventCreationComponent } from '@pages/event-details/event-creation/event-creation.component';
import { EventListTableComponent } from '@pages/event-details/event-list-table/event-list-table.component';
import { WorkshopDetailsComponent } from '@pages/event-details/workshop-details/workshop-details.component';
import { TicketComponent } from '@pages/ticket/ticket.component';
import { PrivacyPolicyComponent } from '@modules/privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from '@modules/terms-conditions/terms-conditions.component';
import { VolunteerComponent } from '@pages/volunteer/volunteer.component';
import { VolunteerListComponent } from '@pages/volunteer-list/volunteer-list.component';

const routes: Routes = [
    {
        path: 'main',
        component: MainComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        children: [
            {
                path: 'profile',
                component: ProfileComponent
            },
            {
                path: 'blank',
                component: BlankComponent
            },
            {
                path: 'sub-menu-1',
                component: SubMenuComponent
            },
            {
                path: 'sub-menu-2',
                component: BlankComponent
            },
            {
                path: 'dash',
                component: DashboardComponent
            },
           {
            path : "event-creation",
            component: EventCreationComponent
           },
           {
            path : "event-list-table",
            component : EventListTableComponent
           },
           {
            path : 'booking-details',
            component: WorkshopDetailsComponent
          },
           {
            path : 'volunteer-details',
            component: VolunteerListComponent
          },
        ]
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'register',
        component: RegisterComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'recover-password',
        component: RecoverPasswordComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'registration',
        component: RegistrationComponent,
        canActivate: [NonAuthGuard]
    },

    {
        path: 'ticket',
        component: TicketComponent,
        canActivate: [NonAuthGuard]
    },
     {
        path: '',
        component: VolunteerComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'privacy',
        component: PrivacyPolicyComponent,
    },
    {
        path: 'terms',
        component: TermsConditionsComponent,
    },
    {path: '**', redirectTo: ''}
];

@NgModule({
    imports: [RouterModule.forRoot(routes,{ useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule {}
